import { createApp } from '@app/adapters/create-app'
import SfBackInContext from '@app/shared/vue/components/molecules/sf-back-in-context.vue'

onDomLoad(($dom) => {
  $dom.find("[data-behaviour='back-in-context']").each(function () {
    const app = createApp(SfBackInContext)
    app.mount(this)

    document.addEventListener(
      'turbolinks:before-visit',
      () => {
        app.unmount()
      },
      { once: true }
    )
  })
})
